import { render, staticRenderFns } from "./authorizationAdd.vue?vue&type=template&id=6034c35e&scoped=true"
import script from "./authorizationAdd.vue?vue&type=script&lang=js"
export * from "./authorizationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6034c35e",
  null
  
)

export default component.exports